import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SITE_SERVICES } from './homepage2/assets';

// Approved masthead Services dropdown: click/touch, ArrowDown to enter, Escape/focus-out to close.
export const ServicesDropdown = () => {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const btn = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    if (!open) return undefined;
    const away = (e) => { if (!root.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('pointerdown', away);
    return () => document.removeEventListener('pointerdown', away);
  }, [open]);

  const onBtnKey = (e) => {
    if (e.key !== 'ArrowDown') return;
    e.preventDefault();
    setOpen(true);
    requestAnimationFrame(() => root.current?.querySelector('.services-links a')?.focus());
  };
  const onRootKey = (e) => {
    const links = [...root.current.querySelectorAll('.services-links a')];
    const i = links.indexOf(document.activeElement);
    if (e.key === 'Escape') { setOpen(false); btn.current?.focus(); }
    if (i >= 0 && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      e.preventDefault();
      links[(i + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
    }
  };
  const onBlur = () => setTimeout(() => { if (!root.current?.contains(document.activeElement)) setOpen(false); }, 0);

  return (
    <div className="services-dropdown" ref={root} onKeyDown={onRootKey} onBlur={onBlur}>
      <button ref={btn} className="services-trigger" type="button" aria-expanded={open} aria-controls="services-links" onClick={() => setOpen((o) => !o)} onKeyDown={onBtnKey} data-testid="nav-services">
        Services <span aria-hidden="true">⌄</span>
      </button>
      <div className="services-links" id="services-links" hidden={!open} data-testid="nav-services-menu">
        {SITE_SERVICES.map((s) => (
          <Link key={s.path} to={s.path} aria-current={pathname === s.path ? 'page' : undefined} data-testid={`nav-service-${s.path.split('/').pop()}`}>{s.name}</Link>
        ))}
      </div>
    </div>
  );
};
